import { IServices } from "@netent/origin";
import { IAutoplayState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const autoplayState: FeatureStateCreator<IAutoplayState> = (
  services: IServices
): IAutoplayState =>
  services.autoplay.isAvailable()
    ? {
        enabled: !services.gameRound.isRoundActive(),
        rounds: {
          values: services.autoplay.getRoundsAvailable(),
          selected: null,
          left: services.autoplay.getRemaining()
        },
        running: services.autoplay.isActive(),
        settings: [...services.autoplay.getStopConditions()]
      }
    : null;
